import React, { useEffect, useMemo, useState } from "react";
import ProductCard from "../components/ProductCard";
import { PRODUCTS, CATEGORIES } from "../mock";
import { EDITORIAL_IMAGE } from "../mock";
import { fetchProducts } from "../api";

const sortOptions = [
  { value: "featured", label: "Featured" },
  { value: "price-asc", label: "Price: Low to High" },
  { value: "price-desc", label: "Price: High to Low" },
  { value: "rating", label: "Top Rated" }
];

const Shop = () => {
  const [category, setCategory] = useState("All");
  const [sort, setSort] = useState("featured");
  const [allProducts, setAllProducts] = useState(PRODUCTS);

  useEffect(() => {
    fetchProducts()
      .then((data) => {
        if (Array.isArray(data) && data.length) setAllProducts(data);
      })
      .catch(() => {});
  }, []);

  const products = useMemo(() => {
    let list = allProducts.filter((p) => category === "All" || p.category === category);
    if (sort === "price-asc") list = [...list].sort((a, b) => a.price - b.price);
    if (sort === "price-desc") list = [...list].sort((a, b) => b.price - a.price);
    if (sort === "rating") list = [...list].sort((a, b) => b.rating - a.rating);
    return list;
  }, [category, sort, allProducts]);

  return (
    <div>
      {/* Page header */}
      <section className="relative py-24 border-b border-[#2c2822] overflow-hidden">
        <div className="absolute inset-0">
          <img src={EDITORIAL_IMAGE} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0b0a09] via-[#0b0a09]/85 to-[#0b0a09]" />
        </div>
        <div className="relative max-w-[1280px] mx-auto px-6 text-center">
          <p className="text-[#c9a24b] text-sm tracking-[0.3em] uppercase mb-5">Shop</p>
          <h1 className="font-display text-[46px] md:text-[64px] text-[#f4efe4] leading-tight">
            The Full Collection
          </h1>
          <p className="text-[#a29a8c] mt-5 max-w-lg mx-auto">
            Thoughtfully crafted essentials for hair, body and beard — each rooted
            in tradition and powered by nature.
          </p>
        </div>
      </section>

      {/* Filters */}
      <div className="sticky top-[72px] z-30 bg-[#0b0a09]/95 backdrop-blur-md border-b border-[#2c2822]">
        <div className="max-w-[1280px] mx-auto px-6 py-4 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex flex-wrap gap-2">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setCategory(c)}
                className={`px-5 py-2 rounded-full text-xs tracking-[0.15em] uppercase transition-all ${
                  category === c
                    ? "bg-[#c9a24b] text-[#0b0a09] font-medium"
                    : "border border-[#2c2822] text-[#a29a8c] hover:border-[#c9a24b] hover:text-[#c9a24b]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <div className="flex items-center gap-3">
            <span className="text-[#6b6459] text-xs tracking-wide uppercase">Sort</span>
            <select
              value={sort}
              onChange={(e) => setSort(e.target.value)}
              className="bg-[#141210] border border-[#2c2822] text-[#f4efe4] text-sm rounded-full px-4 py-2 outline-none focus:border-[#c9a24b] transition-colors cursor-pointer"
            >
              {sortOptions.map((o) => (
                <option key={o.value} value={o.value} className="bg-[#141210]">
                  {o.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Grid */}
      <section className="max-w-[1280px] mx-auto px-6 py-16">
        <p className="text-[#a29a8c] text-sm mb-8">{products.length} products</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Shop;
